import { render, staticRenderFns } from "./FamiliareDetail.vue?vue&type=template&id=15a61250"
import script from "./FamiliareDetail.vue?vue&type=script&lang=js"
export * from "./FamiliareDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports